export function getOneTrustDataDomainScript() {
  var isTestEnvironment = true && window.location.host.endsWith('.testmiro.com');
  return isTestEnvironment ? '4133a0ef-6999-461d-909d-24f2b05bbc15-test' : '4133a0ef-6999-461d-909d-24f2b05bbc15';
}